// @ts-nocheck
import { getDateObj } from '$lib/utils'
import { writable } from 'svelte/store'

const orderByDate = (a, b) => (a.date.getTime() > b.date.getTime() ? 1 : -1)
function createChatStore({
    messages = [],
    defaultState = 'sync',
    callback = () => {},
}) {
    const index = new Set()
    const { subscribe, set, update } = writable([])
    const insert = (msg) => {
        let { id = null, status = defaultState, ...data } = msg
        if (id && index.has(id)) {
            throw new Error('Duplicate msg id key.')
        }
        if (!id) id = crypto.randomUUID()
        let tmp = {
            id,
            ...data,
            status,
            order: index.size + 1,
            date: msg?.date instanceof Date ? msg.date : getDateObj(msg?.date),
        }
        index.add(id)
        update((messages) => [...messages, tmp])
        callback(tmp)
        return tmp
    }
    const forceRefresh = () => {
        update((messages) => [...messages])
    }
    if (messages instanceof Array) {
        messages.forEach((msg) => {
            try {
                insert(msg)
            } catch (e) {}
        })
    }
    return {
        subscribe,
        insert,
        push: (msg) => {
            try {
                insert(msg)
            } catch (_) {}
        },
        delete: (id) => {
            index.delete(id)
            update((messages) => messages.filter((x) => id !== x.id))
            forceRefresh()
        },
        sort: ({ key = (x) => x, asc = true }) => {
            let ord = asc ? 1 : -1
            let ret
            let func = typeof key === 'function' ? key : (x) => x[key]
            update((messages) => {
                ret = messages.sort((a, b) =>
                    func(a) > func(b) ? ord * 1 : -1 * ord
                )
                return ret
            })
            return ret
        },
        updateMsg: (id, data) => {
            let { id: newId = null } = data.id
            if (newId) {
                index.delete(id)
                index.add(newId)
            }
            update((messages) =>
                messages.map((msg) =>
                    msg?.id ? (msg.id === id ? { ...msg, ...data } : msg) : msg
                )
            )
        },
        forceRefresh,
        count: () => index.size,
        drop: () => {
            set([])
        },
        get value() {
            let ret
            subscribe((r) => {ret = r})
            return ret
        },
        get lastDate() {
            let date = this.value?.sort(orderByDate)?.at(-1)?.date
            if (date) date.setMilliseconds(date.getMilliseconds() + 1)
            return date || new Date('1970-01-01T00:00:00Z')
        },
        set callback(func) {
            callback = func
        },
        update,
    }
}

export default createChatStore
